export const localeToCurrency = {
  "en-US": "USD",
  "en-CA": "CAD"
};

export const localeToCurrencySymbol = {
  "en-US": "$",
  "en-CA": "CAD "
};

export const localeToCurrencyText = {
  "en-US": "Dollar ($)",
  "en-CA": "(Dollar) CAD"
};

export const countryToLocale = {
  "USA": "en-US",
  "CAN": "en-CA"
}
